import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import RevenueChartTooltip from 'widgets/charts/RevenueChartTooltip'
import LineChartWidget from 'widgets/charts/LineChartWidget'

export default function LineChartLoader () {
  const entries = useValue('entries', [])

  const hourly = entries && entries[0] ? !!(entries[0].hourly) : false

  const lines = [
    {
      dataKey: 'total_revenue',
      stroke: '#616DE1'
    }
  ]

  if (!hourly) {
    lines.push({
      dataKey: 'locked_forecast',
      stroke: '#E5483F'
    })
  }

  return (
    <LineChartWidget
      data={entries}
      lines={lines}
      hourly={hourly}
      tooltipContent={<RevenueChartTooltip />}
      xDataKey='timestamp'
      yTick={{
        type: 'currency'
      }}
    />
  )
}
